import { ICaseSearchResultModel } from "us.common/reducers/MainSearch/Interfaces";

export const CaseSearchModel: ICaseSearchResultModel = {
  data: [],
  isError: false,
  isLoading: false,
};
